import type { SortCriteria } from '$lib/types/leaderboard';
import { api_trade_stats } from './utils';

export async function fetchLeaderboardRecords(id: string, sortCriteria: SortCriteria, count = 10) {
	if (!id || !sortCriteria) return;
	const response = await api_trade_stats(
		'get',
		`trading-competitions/${id}/stats?sortCriteria=${sortCriteria}&count=${count}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchLeaderboardRecord(
	id: string,
	sortCriteria: SortCriteria,
	account: string,
	count = 10
) {
	if (!id || !sortCriteria || !account) return;
	const response = await api_trade_stats(
		'get',
		`trading-competitions/${id}/stats?sortCriteria=${sortCriteria}&account=${account}&count=${count}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchCompetitionConfig(id: string) {
	if (!id) return;
	const response = await api_trade_stats('get', `trading-competitions/${id}`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
